import React, { useEffect, useState } from 'react'
import { ICoordinates, IDriverSearchObject, ILastOperatorLocation, IZoneObject } from 'src/types'
import { getDriverSchedule } from 'src/state/actions/drivers'
import { GoogleMap } from 'react-google-maps'
import StandardGoogleMaps from 'src/containers/googleMap/StandardGoogleMaps'
import moment from 'moment'
import { classNames } from 'react-select/src/utils'

export interface IDriverLocationProps {
  operatorId: string
  orgId: string
  currentOperator: IDriverSearchObject
  zones: { [key: string]: IZoneObject } | {}
  operatorLocation?: ILastOperatorLocation | undefined
  clearMap: () => void
  getLocation: (operatorId: string) => void
}

export interface IDriverSchedule {
  days: string[]
  from: string
  is_archived: boolean
  until: string
  errorDays?: string[]
}

export interface IDriverScheduleResponse {
  success: boolean
  serviceDays: IDriverSchedule[]
}

const DriverViewLocation = (props: IDriverLocationProps) => {
  useEffect(() => {
    props.getLocation(props.operatorId)
    return () => {
      props.clearMap()
    }
  }, [])

  const center: ICoordinates | undefined = props.operatorLocation
    ? {
        lat: props.operatorLocation.last_latitude,
        lng: props.operatorLocation.last_longitude
      }
    : undefined
  return (
    <div>
      <div className='h4 mt3 bold font-dark-grey flex justify-between px2'>
        <p>Driver last location</p>
        {props.operatorLocation && (
          <p className='pr-2'>Updated: {moment(props.operatorLocation.last_updated).fromNow()}</p>
        )}
      </div>

      <StandardGoogleMaps
        isDragable={false}
        renderStrategyStage={'SHOW_NEARBY_DRIVERS'}
        operatorLocation={props.operatorLocation}
      />
    </div>
  )
}
export default DriverViewLocation



// WEBPACK FOOTER //
// ./src/components/drivers/DriverViewLocation.tsx